import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { GET_TOP } from '@/store/top/actions'
import { loadView } from '@/helper/utils'
import { mainLayout } from '@/components/layouts/Main'
import NotFound from '@/components/404.vue'
import actor from './actor'
import carrier from './carrier'
import clientLp from './clientLp'
import genre from './genre'
import horoscope from './horoscope'
import line from './line'
import lineTop from './lineTop'
import lp from './lp'
import mail from './mail'
import page from './page'
import pageLp from './pageLp'
import point from './point'
import restriction from './restriction'
import support from './support'
import user from './user'

import {
  FETCH_LOGIN_USER
} from '@/store/top/mutations'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Top',
    component: mainLayout(loadView('top/Top'), true)
  },
  actor,
  carrier,
  clientLp,
  genre,
  horoscope,
  line,
  lineTop,
  lp,
  mail,
  page,
  pageLp,
  point,
  restriction,
  support,
  user,
  {
    path: '*',
    name: 'NotFound',
    component: mainLayout(NotFound)
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    // ハッシュがあるときはページスクロールだから何もしない
    if (to.hash) {
      return
    }

    if (savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition)
        })
      })
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // 対象外端末除外(プレビューは除外する)
  if (!to.name.match(/Page.*Preview/)) {
    // PCはLPページへ遷移
    if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
      // スマホ・タブレット（iOS・Android）の場合の処理を記述
    } else {
      // PCの場合の処理を記述
      const pcRedirectUrl = process.env.VUE_APP_PC_REDIRECT_URL
      if (pcRedirectUrl.length > 0) {
        window.location = pcRedirectUrl
      }
    }
  }

  const oldIsses = from.query.isses || null
  const newIsses = to.query.isses || null

  // クレジットカード(RS)からの戻りで付与されるユーザ識別子等
  const sendsId = to.query.sendsid || null
  if (sendsId != null) {
    delete to.query.sendsid
    // sendsidをオーダー番号とissesに分割する
    const orders = sendsId.split('orders')
    // 新しいセッションを付与する
    to.query.isses = orders[1]
    to.query.oid = orders[0]
    next(to)
    return
  }

  // 後払い(Paidy)からの戻りで付与されるオーダー番号をoidに変換する
  const gpayCookie = to.query.cookie || null
  if (to.name && to.name.match(/^PointGpay(Complete|Cancel|Error)$/) && gpayCookie != null) {
    const query = {
      isses: to.query.isses,
      oid: gpayCookie.replace(/[^0-9]/g, '')
    }
    next({ path: to.path, query: query })
    return
  }

  if (oldIsses != null && newIsses == null) {
    // セッションを引き回す
    to.query.isses = oldIsses
    next(to)
    return
  }

  // セッションが変わったのでユーザ情報を削除する
  if (oldIsses !== newIsses) {
    store.commit(FETCH_LOGIN_USER, null)
  }

  const isses = to.query.isses || null

  // セッションが消えたのでユーザ情報を削除する
  if (isses == null) {
    store.commit(FETCH_LOGIN_USER, null)
    // 認証が必要なページではトップページへリダイレクトする
    if (to.matched.some(record => record.meta.requiresAuth)) {
      next('/')
      return
    }
  }

  getTopNext(to, next, oldIsses, newIsses)
})

router.pushIsses = function (params, isAuth = true) {
  const urlParams = new URLSearchParams(document.location.search.substring(1))
  const isses = urlParams.get('isses') || ''

  if (!isAuth) {
    router.push(params)
  } else if (typeof params === 'object') {
    const query = params.query || {}
    query.isses = isses
    params.query = query
    router.push(params)
  } else if (typeof params === 'string') {
    let resource = ''
    if (isses === '' || params.indexOf('?isses=') !== -1 || params.indexOf('&isses=') !== -1) {
      resource = params
    } else if (resource.indexOf('?') !== -1) {
      resource = params + `&isses=${isses}`
    } else {
      resource = params + `?isses=${isses}`
    }
    router.push(resource)
  } else {
    router.push(params)
  }
}

const getTopNext = function (to, next, oldIsses, newIsses) {
  const params = {}
  if (newIsses != null) {
    if (oldIsses !== newIsses) {
      params.params = {
        isses: newIsses
      }
    }
  }

  store.dispatch(GET_TOP, params)
    .then((data) => {
      if (data.redirect_url !== undefined && data.redirect_url !== null) {
        window.location = data.redirect_url
      } else if (data.user == null) {
        store.commit(FETCH_LOGIN_USER, null)
        if (to.matched.some(record => record.meta.requiresAuth)) {
          next('/')
        } else {
          next()
        }
      } else if (to.name.match(/Restriction/)) {
        if (data.user.status === 'enabled') {
          router.pushIsses({ name: 'Top' })
        } else {
          next()
        }
      } else if (data.user.status === 'lock') {
        router.pushIsses({ name: 'RestrictionLock' })
      } else if (data.user.status === 'withdrawal') {
        router.pushIsses({ name: 'RestrictionWithdrawal' })
      } else if (data.user.status === 'closed') {
        router.pushIsses({ name: 'RestrictionBlack' })
      } else {
        next()
      }
    })
    .catch(() => next())
}

export default router
